import {
  DEFAULT_DASHBOARD_VIEW,
  DEFAULT_SESSION_KEY,
  NEW_DASHBOARD_ROUTES,
  DASHBOARD_URL,
  MESSAGING_URL,
  MESSAGING_COMPOSE_URL,
  DEFAULT_TOGGLE_KEY,
  NEW_DASHBOARD_URL,
  MESSAGE_NAV_KEY,
  DEFAULT_EMPLOYEE_KEY,
  DEFAULT_FORM_KEY,
  TASK_STATUS,
} from 'src/constants/constants';
import _ from 'lodash';

export const fnIsDefaultOldView = () => {
  let default_view = sessionStorage.getItem(DEFAULT_SESSION_KEY);
  return default_view === null
    ? (process.env.SHOW_DEFAULT_OLD_VIEW_ENV || 'false').toLowerCase() === 'true'
    : default_view.toLowerCase() === DEFAULT_DASHBOARD_VIEW.EXISTING.toLowerCase();
};

export const getDashboardURL = () => (fnIsDefaultOldView() ? DASHBOARD_URL : NEW_DASHBOARD_URL);

export const fnShowNewDashboard = () => {
  let showDashboardSideNav = false;
  let isDefaultOldView = fnIsDefaultOldView();
  if (!isDefaultOldView) {
    showDashboardSideNav =
      _.filter(
        Object.values(NEW_DASHBOARD_ROUTES),
        i =>
          i !== '/' && window.location && window.location.pathname && window.location.pathname.toLowerCase().indexOf(i.toLowerCase()) > -1,
      ).length > 0;
    if (sessionStorage.getItem('case_nav') === true) {
      showDashboardSideNav = false;
    }
  }
  return showDashboardSideNav;
};

export const fnRedirectedCaseId = () => {
  let caseId;
  if (
    window.location &&
    window.location.pathname &&
    window.location.pathname.toLowerCase().indexOf(MESSAGING_URL) !== -1 &&
    window.location.pathname.toLowerCase().indexOf(MESSAGING_COMPOSE_URL) === -1
  ) {
    let pathSplit = _.split(window.location.pathname, '/');
    caseId = pathSplit.length === 3 ? _.last(pathSplit) : '';
  }
  return caseId;
};

export const fnInsertStoragekey = (key, value) => sessionStorage.setItem(key, value);
export const fnRemoveMessageKey = () => sessionStorage.removeItem(MESSAGE_NAV_KEY);
export const fnGetMessageValue = () => sessionStorage.getItem(MESSAGE_NAV_KEY);

export const fnSetIsAllDataFlag = value => {
  sessionStorage.setItem(DEFAULT_TOGGLE_KEY, JSON.stringify({ isAllData: value }));
};
export const fnSetIsAllCaseToggle = value => {
  sessionStorage.setItem(DEFAULT_TOGGLE_KEY, JSON.stringify({ isAllCaseAction: value, isAllData: fnGetIsAllDataFlag() }));
};

export const fnGetIsAllDataFlag = () => {
  let value = sessionStorage.getItem(DEFAULT_TOGGLE_KEY);
  if (value) {
    value = JSON.parse(value);
    return value && (value.isAllData ? value.isAllData : false);
  }
  return false;
};
export const fnGetIsAllCaseToggle = () => {
  let value = sessionStorage.getItem(DEFAULT_TOGGLE_KEY);
  if (value) {
    value = JSON.parse(value);
    return value && (value.isAllCaseAction ? value.isAllCaseAction : false);
  }
  return false;
};
export const fnGetCaseRelatedId = index => {
  return window && window.location && window.location.pathname ? _.nth(window.location.pathname.split('/'), index) : '';
};

export const fnGetCaseData = () => {
  return window && window.location && window.location.pathname ? window.location.pathname.includes('case-data') : '';
};

export const fnOnNavOpen = () => {
  const element = document.getElementsByClassName('persistent-menu-button');
  if (element && element.length > 0 && element[0].ariaExpanded.toLowerCase() === 'true') {
    const childElement = document.getElementsByClassName('persistent-menu-list-item');
    if (childElement && childElement.length > 0 && childElement[0].ariaExpanded.toLowerCase() === 'true') {
      return;
    }
    element[0].click();
  }
};

export const fnGetDashboardView = () => {
  return sessionStorage.getItem('default_view').toLowerCase() === 'new';
};

export const isActiveMenu = path => {
  if (!path) return false;
  return window.location && window.location.pathname && window.location.pathname.toLowerCase().indexOf(path.toLowerCase()) !== -1
    ? ' active'
    : '';
};

export const fnGetMenuTypeCode = data => {
  let menu = _.find(data.menuDetails, x => _.find(x.subMenu, y => y.pageId === fnGetCaseRelatedId(4)));
  return menu ? menu.menuTypeCode : null;
};

export const fnResetPageState = (menuDetails, questionnaireId, pageId) => {
  let menuObj = menuDetails.map(menu => {
    if (menu.pageId === questionnaireId) {
      const subMenu = menu.subMenu.map(page => {
        if (page.pageId === pageId) {
          return { ...page, pageState: 'InComplete' };
        }
        return page;
      });
      return { ...menu, subMenu: subMenu };
    }
    return menu;
  });
  return menuObj;
};
export const fnSetEmployeeLookup = response => {
  sessionStorage.setItem(DEFAULT_EMPLOYEE_KEY, JSON.stringify({ lookup: response }));
};

export const fnIsEmployeePresentAvailable = () => {
  return sessionStorage.getItem(DEFAULT_EMPLOYEE_KEY);
};

export const fnIsEmployeePresent = searchText => {
  let value = sessionStorage.getItem(DEFAULT_EMPLOYEE_KEY);
  if (value) {
    value = JSON.parse(value);
    return value && searchText === '';
  }
  return false;
};

export const fnGetEmployeeLookup = () => {
  let value = sessionStorage.getItem(DEFAULT_EMPLOYEE_KEY);
  value = JSON.parse(value);
  return value.lookup;
};
export const fnRemoveEmployeeKey = () => sessionStorage.removeItem(DEFAULT_EMPLOYEE_KEY);

export const fnSetEmployeForm = response => {
  sessionStorage.setItem(DEFAULT_FORM_KEY, JSON.stringify({ form: response }));
};

export const fnIsEmployeeFormPresent = () => {
  let value = sessionStorage.getItem(DEFAULT_FORM_KEY);
  if (value) {
    return true;
  }
  return false;
};

export const fnGetEmployeeForm = () => {
  let value = sessionStorage.getItem(DEFAULT_FORM_KEY);
  value = JSON.parse(value);
  return value.form;
};
export const fnRemoveEmployeeFormKey = () => sessionStorage.removeItem(DEFAULT_FORM_KEY);

export const commonFormatDate = inputDate => {
  const dateParts = inputDate.split(' ');
  let delimiter = '/';
  if (dateParts[0].includes('-')) {
    delimiter = '-';
  }
  const parts = dateParts[0].split(delimiter);
  const day = parts[1].padStart(2, '0');
  const month = new Date(inputDate).toLocaleString('default', { month: 'short' });
  const year = parseInt(parts[2]);
  let formattedDate = day + ' ' + month + ' ' + year;
  if (inputDate.includes(':')) {
    const time = inputDate.split(' ')[1] + ' ' + inputDate.split(' ')[2];
    formattedDate += ' ' + time;
  }
  return formattedDate;
};

export const dateFormatEnUS = inputDate => {
  let parts = '';
  if (inputDate.includes('-')) parts = inputDate.split('-');
  else {
    parts = inputDate.split('/');
  }
  const year = parts[0];
  const month = new Date(inputDate).toLocaleString('default', { month: 'short' });
  const day = parts[2].padStart(2, '0');
  return `${day} ${month} ${year}`;
};

export const extractTimeFromDate = inputDate => {
  const moment = require('moment');
  const date = moment(inputDate, 'DD MMM YYYY, hh:mma').toDate();
  const year = date.getFullYear();
  const month = date.toLocaleString('default', { month: 'short' });
  const day = date.getDate();

  return `${day} ${month} ${year}`;
};

export const fnIsPageCompleted = (menuDetails, questionnaireId, pageId) => {
  const menuObj = menuDetails.filter(menu => menu.pageId === questionnaireId);
  const subMenuObj = menuObj[0] && menuObj[0].subMenu.filter(page => page.pageId === pageId);
  return subMenuObj[0] && subMenuObj[0].pageState !== TASK_STATUS.OPEN;
};
